
import { defineComponent } from "vue";
import firebase from "firebase/app";
import FirebaseUI from "@/components/FirebaseUI.vue";

export default defineComponent({
  components: {
    FirebaseUI
  },
  data() {
    return {
      authStateKnown: false,
      authenticated: false,
      desktopSignInLoading: false,
      desktopSignInError: "",
      user: null as null | firebase.User
    };
  },
  computed: {
    target(): string | string[] | null {
      const { target = null } = this.$route.params;
      return target;
    },
    redirectUrl(): string {
      switch (this.target) {
        case "desktop-sign-in":
          return ("/auth/desktop-sign-in?ot-auth-code=" +
            this.$route.query["ot-auth-code"]) as string;
        default:
          return "/admin";
      }
    }
  },
  async mounted() {
    firebase.auth().onAuthStateChanged(user => {
      this.authStateKnown = true;
      if (user) {
        this.authenticated = true;
        this.user = user;
        switch (this.target) {
          case "desktop-sign-in":
            this.desktopSignIn(user);
            break;
          default:
            // Pass
            break;
        }
      } else {
        this.authenticated = false;
        this.user = null;
      }
    });
  },
  methods: {
    async desktopSignIn(user: firebase.User) {
      this.desktopSignInLoading = true;
      const otCode = this.$route.query["ot-auth-code"];
      const idToken = await user.getIdToken();
      const createAuthToken = firebase
        .functions()
        .httpsCallable("createAuthToken");
      try {
        await createAuthToken({ otCode, idToken });
        this.desktopSignInLoading = false;
      } catch (error) {
        this.desktopSignInError = error.message;
        console.error(error);
      }
    },
    openDesktopApp() {
      window.location.href = `${
        process.env.VUE_APP_ENDPOINTS === "production"
          ? "samply"
          : "samplystaging"
      }://`;
    },
    logout() {
      firebase.auth().signOut();
    }
  }
});
